import { render, staticRenderFns } from "./FeatureAccessModal.vue?vue&type=template&id=e9ca4a5e&scoped=true"
import script from "./FeatureAccessModal.vue?vue&type=script&lang=js"
export * from "./FeatureAccessModal.vue?vue&type=script&lang=js"
import style0 from "./FeatureAccessModal.vue?vue&type=style&index=0&id=e9ca4a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ca4a5e",
  null
  
)

export default component.exports